<template>
  <div id="noPermission">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "noPermission",
};
</script>